import { useContext } from "react";
import SideBar from "../Components/SideBar/SideBar";
import { CircularProgress } from "@mui/material";
import AuthContext from "../Hooks/AuthContext/AuthContext";
import AssistantWidget from "../Components/Assistant/AssistantWidget";
export interface AdminPanelProps {
  children: any;
}

const AdminDashboardLayout = (props: AdminPanelProps) => {
  const { auth } = useContext(AuthContext);

  return (
    <div>
      {auth != null && auth.user != null ? (
        <div className="bg-slate-50 h-screen">
          <section>
            <SideBar dashboard={true} />
          </section>

          <div className="ml-20  lg:ml-60 mt-16 bg-slate-50  h-screen">
            {props.children}
          </div>
        </div>
      ) : (
        <div className="flex w-full justify-center mt-48">
          <div className="inline justify-center text-center">
            <img
              src="/img/full_logo.png"
              alt="Logo"
              style={{
                width: "200px",
              }}
            ></img><br />
            <CircularProgress />
          </div>
        </div>
      )}
      {/* Mounted here (not per page) so the conversation survives navigation; renders nothing unless the user may use it. */}
      <AssistantWidget />
    </div>
  );
};

export default AdminDashboardLayout;
